import { IndexedFiles } from './object-fs';
import { actions } from './object-fs';
import { ObjectFs } from './object-fs';

//should handle all the specific implementation for playground

export class PlaygroundFs extends ObjectFs {
	constructor(files?: IndexedFiles) {
		super();

		if (files) {
			this.store.dispatch({
				type: actions.SET_FILES,
				files: files,
			});
		}
	}

	get files() {
		const state = this.store.getState();
		return state.files;
	}
}
